import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../services/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vibe_token');
    if (token) {
      API.get('/auth/me')
        .then(res => setUser(res.data.user))
        .catch(() => { localStorage.removeItem('vibe_token'); localStorage.removeItem('vibe_user'); })
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (data) => {
    const res = await API.post('/auth/login', data);
    localStorage.setItem('vibe_token', res.data.token);
    localStorage.setItem('vibe_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (data) => {
    const res = await API.post('/auth/register', data);
    localStorage.setItem('vibe_token', res.data.token);
    localStorage.setItem('vibe_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('vibe_token');
    localStorage.removeItem('vibe_user');
    setUser(null);
  };

  const updateUser = (u) => { setUser(u); localStorage.setItem('vibe_user', JSON.stringify(u)); };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
